/** Дефолтний каталог (uk) — джерело істини для форми повідомлень (MessageSchema). */
export default {
  app: {
    title: "Salonos",
  },
  layout: {
    aria: {
      sidebar: "Бічна навігація",
      sections: "Розділи",
      moreSections: "Розділи налаштувань",
      topbar: "Верхня панель",
      bottomnav: "Нижня навігація",
    },
    account: {
      menuLabel: "Меню акаунта",
      logout: "Вийти",
    },
    more: {
      title: "Ще",
      description: "Розділи налаштувань салону",
      close: "Закрити",
    },
  },
  nav: {
    zones: {
      daily: "Щоденна робота",
      settings: "Налаштування салону",
    },
    journal: "Записи",
    schedule: "Графік",
    more: "Ще",
    clients: "Клієнти",
    summary: "Статистика",
    masters: "Майстри",
    services: "Послуги",
    salonProfile: "Профіль салону",
  },
  sections: {
    inDevelopment: "Розділ у розробці",
    inDevelopmentHint: "Цей розділ зʼявиться найближчим часом.",
  },
  services: {
    title: "Послуги",
    subtitle: "Керуйте каталогом послуг салону",
    loading: "Завантаження…",
    listError: "Не вдалося завантажити послуги",
    retry: "Спробувати знову",
    saving: "збереження…",
    assignedCount: "{count} майстер | {count} майстри | {count} майстрів",
    row: {
      addMaster: "Майстер",
    },
    draft: {
      placeholder: "Додати послугу",
      placeholderNext: "Наступна послуга…",
      addToCategory: "Додати послугу в {name}",
    },
    actions: {
      rename: "Перейменувати",
      delete: "Видалити",
      save: "Зберегти",
      cancel: "Скасувати",
      retry: "Повторити",
      dismiss: "Прибрати",
      confirm: "Підтвердити",
      addService: "Додати послугу",
      move: "Перемістити до категорії",
      moveToCategory: "Перемістити в категорію",
      moveHere: "Перемістити сюди",
    },
    detail: {
      sheetTitle: "Майстри послуги",
      ctxLabel: "Послуга",
      mastersSection: "Майстри",
      masterCount: "{count} майстер | {count} майстри | {count} майстрів",
      addMaster: "Додати майстра",
      manageMenuLabel: "Управляти послугою",
      renameConfirm: "Підтвердити",
      renameCancel: "Скасувати",
      currentCategoryHint: "зараз тут",
      empty: {
        title: "Ще немає майстрів на цю послугу",
        body: "Додайте майстра й задайте, скільки коштує і триває послуга саме в нього. Без майстра послуга не зʼявиться у записі.",
      },
      master: {
        meta: "{duration} хв · {price} · буфер {buffer} хв",
        bufferMeta: "буфер {buffer} хв",
        edit: "Змінити",
      },
      assignedError: "Не вдалося завантажити майстрів",
      retry: "Повторити",
      addMoreMaster: "Додати майстра",
      done: "Готово",
      bannerAdded: "Майстра {name} додано на «{service}»",
      closeLabel: "Закрити",
    },
    categories: {
      title: "Без категорії",
      add: "Нова категорія",
      saved: "Категорію збережено",
      deleted: "Категорію видалено",
      addPlaceholder: "Назва категорії",
      uncategorized: "Без категорії",
      assignHint: "Щоб призначити категорію, відкрийте послугу → ⋯ → «Перемістити в категорію».",
      renameCategory: "Перейменувати категорію",
      deleteCategory: "Видалити категорію",
      deleteKeepsServices: "Послуги переміщуються в «Без категорії», а не видаляються.",
      count: "{count} послуга | {count} послуги | {count} послуг",
    },
    delete: {
      confirm: "Видалити «{name}»?",
      base: "Послугу буде видалено з каталогу. Цю дію не можна скасувати.",
      assignedWarning: "До послуги прикріплено {count} майстра. Він відкріпиться разом з нею. | До послуги прикріплено {count} майстри. Вони відкріпляться разом з нею. | До послуги прикріплено {count} майстрів. Вони відкріпляться разом з нею.",
      blocked: "Послуга призначена майстрам. Спершу зніміть її в картках майстрів.",
    },
    errors: {
      invalidName: "Вкажіть коректну назву (до 200 символів).",
      notFound: "Послугу вже видалено.",
      inUse: "Послуга призначена майстрам. Спершу зніміть її в картках майстрів.",
      serviceInUse: "Майстер має заплановані записи на цю послугу. Скасуйте або перенесіть їх.",
    },
    empty: {
      category: "У цій категорії ще немає послуг.",
      firstRun: {
        title: "Каталог послуг порожній",
        body: "Згрупуйте послуги за категоріями — так клієнти краще орієнтуються.",
        cta: "Нова категорія",
      },
    },
    a11y: {
      editLabel: "Назва послуги",
      savedAnnounce: "{name} збережено",
      deletedAnnounce: "{name} видалено",
      serviceActions: "Дії послуги «{name}»",
      categoryActions: "Дії категорії «{name}»",
      moveLabel: "Категорія для «{name}»",
      collapseCategory: "Згорнути категорію «{name}»",
      expandCategory: "Розгорнути категорію «{name}»",
    },
    assign: {
      picker: {
        title: "Оберіть майстра",
        search: "Пошук майстра…",
        next: "Далі — налаштувати",
        createNew: "Створити нового майстра",
      },
      config: {
        save: "Зберегти",
        cancel: "Скасувати",
        detach: "Відкріпити",
      },
      create: {
        nameLabel: "Імʼя",
        phoneLabel: "Телефон",
        hint: "Майстра закріплено за послугою — змінити можна на сторінці майстрів",
        mastersLink: "Сторінка майстрів",
      },
    },
    detach: {
      trigger: "Відкріпити майстра",
      dangerLabel: "Небезпечна дія",
      hint: "Майстер більше не надаватиме цю послугу. Ціну й тривалість цього звʼязку буде втрачено.",
      confirmTitle: "Відкріпити майстра від послуги?",
      confirmBody: "{master} більше не надаватиме послугу «{service}». Введені ціну й тривалість буде видалено — при повторному призначенні їх треба вказати знову.",
      confirm: "Відкріпити",
      close: "Закрити",
    },
  },
  masters: {
    title: "Майстри",
    subtitle: "Заводьте майстрів салону, редагуйте та видаляйте їхні профілі.",
    add: "Додати майстра",
    backToList: "До списку",
    setupHint: {
      services: "Оберіть майстра, щоб додати ціни й час послуг",
      schedule: "Оберіть майстра, щоб налаштувати розклад роботи",
    },
    tabs: {
      profile: "Профіль",
      photo: "Фото",
      schedule: "Розклад",
      services: "Послуги",
    },
    photo: {
      empty: "Фото ще немає",
      hint: "JPEG або PNG",
      actions: {
        upload: "Завантажити фото",
        replace: "Замінити фото",
        remove: "Прибрати фото",
        confirm: "Завантажити",
        cancel: "Скасувати",
      },
      remove: {
        title: "Прибрати фото?",
        description: "Фото майстра буде видалено. Цю дію можна скасувати, завантаживши фото знову.",
        confirm: "Прибрати",
      },
      a11y: {
        preview: "Фото майстра {name}",
        uploaded: "Фото оновлено",
        removed: "Фото прибрано",
        changeButton: "Змінити фото майстра",
      },
      errors: {
        unsupportedType: "Підтримуються лише JPEG та PNG",
        invalidImage: "Не вдалося прочитати зображення або воно завелике за розмірами",
        tooLarge: "Файл завеликий",
        uploadFailed: "Не вдалося завантажити фото",
        masterGone: "Майстра вже немає, оновіть список",
      },
    },
    loading: "Завантаження…",
    listError: "Не вдалося завантажити майстрів",
    retry: "Спробувати знову",
    empty: {
      title: "Майстрів ще немає",
      body: "Заведіть першого майстра — він зʼявиться у списку та стане доступним для записів.",
      cta: "Додати майстра",
    },
    loadError: "Не вдалося завантажити майстра",
    fields: {
      firstName: "Імʼя",
      lastName: "Прізвище",
      middleName: "По батькові",
      email: "Email",
      phone: "Телефон",
      hint: {
        middleName: "необовʼязково",
      },
    },
    actions: {
      save: "Зберегти",
      cancel: "Скасувати",
      delete: "Видалити",
      create: "Додати майстра",
    },
    delete: {
      title: "Видалити майстра?",
      confirm: "Дія незворотна. Профіль майстра {name} буде видалено без можливості відновлення.",
      blocked: "У майстра є призначені послуги. Спершу зніміть їх, тоді профіль можна видалити.",
    },
    notFound: {
      title: "Майстра вже немає",
      body: "Цього майстра видалено або посилання неправильне.",
      backCta: "На список",
    },
    a11y: {
      createdAnnounce: "Майстра {name} додано",
      savedAnnounce: "Зміни профілю {name} збережено",
      deletedAnnounce: "Майстра видалено",
      avatarLabel: "Аватар майстра",
    },
    sections: {
      profile: "Профіль",
      services: "Послуги",
      schedule: "Розклад",
      portfolio: "Портфоліо",
      dangerZone: "Небезпечна зона",
    },
    dangerZone: {
      description: "Видалення майстра незворотне.",
    },
    errors: {
      firstNameRequired: "Введіть імʼя",
      lastNameRequired: "Введіть прізвище",
      nameTooLong: "Занадто довге значення (максимум 100 символів)",
      invalidName: "Перевірте ПІБ майстра",
      invalidFirstName: "Перевірте імʼя",
      invalidMiddleName: "Перевірте по батькові",
      invalidLastName: "Перевірте прізвище",
      invalidEmail: "Невірний формат email",
      invalidPhone: "Невірний формат телефону",
      inUse: "У майстра є призначені послуги. Спершу зніміть їх.",
      notFound: "Майстра вже немає",
    },
    schedule: {
      weekdays: {
        "1": "Понеділок",
        "2": "Вівторок",
        "3": "Середа",
        "4": "Четвер",
        "5": "Пʼятниця",
        "6": "Субота",
        "7": "Неділя",
      },
      dayOff: "Вихідний",
      from: "Початок",
      to: "Кінець",
      save: "Зберегти розклад",
      edit: "Редагувати розклад",
      loadError: "Не вдалося завантажити розклад",
      empty: {
        title: "Розклад не налаштовано",
        description: "Без розкладу майстер недоступний для онлайн-запису.",
      },
      a11y: {
        saved: "Розклад збережено",
        dayToggle: "{day} — робочий день",
        startLabel: "Початок — {day}",
        endLabel: "Кінець — {day}",
        loading: "Завантаження розкладу…",
      },
      setup: {
        cta: "Налаштувати розклад",
        title: "Налаштувати розклад",
        presets: {
          monFri: "Пн-Пт",
          monSat: "Пн-Сб",
          daily: "Щодня",
          clearAll: "Очистити",
        },
        apply: "Застосувати",
        close: "Закрити",
      },
      errors: {
        startBeforeEnd: "Початок має бути раніше кінця",
        invalid_working_hours: "Перевірте робочі години (початок раніше кінця, крок 15 хв)",
        invalid_weekday: "Невірний день тижня",
        duplicate_weekday: "День тижня вказано двічі",
        saveFailed: "Не вдалося зберегти розклад",
      },
    },
    services: {
      saved: "Послугу збережено",
      removed: "Послугу знято",
      unknownService: "[Видалено]",
      unknownMaster: "Невідомий майстер",
      errors: {
        serviceRequired: "Оберіть послугу",
        invalidDuration: "Вкажіть коректну тривалість (хвилини, 1–480)",
        invalidPrice: "Вкажіть коректну ціну (від 0)",
        invalidBuffer: "Вкажіть коректний буфер (хвилини, 0–120)",
        serviceGone: "Послугу видалено з каталогу. Список оновлено.",
        linkGone: "Призначення вже знято іншим сеансом",
        serviceInUse: "Майстер має заплановані записи на цю послугу. Скасуйте або перенесіть їх.",
      },
      add: "Додати послугу",
      loading: "Завантаження…",
      listError: "Не вдалося завантажити послуги",
      retry: "Спробувати знову",
      empty: {
        title: "Послуг ще немає",
        body: "Додайте послуги, які надає цей майстер.",
        cta: "Додати послугу",
      },
      emptyCatalog: {
        title: "Спершу створіть послуги",
        body: "У салоні ще немає послуг. Створіть їх у розділі «Послуги».",
        cta: "До послуг",
      },
      row: {
        summary: "{duration} хв · {price} · буфер {buffer} хв",
      },
      units: {
        min: "хв",
        hour: "год",
      },
      actions: {
        edit: "Редагувати",
        detach: "Прибрати",
        save: "Зберегти",
        cancel: "Скасувати",
      },
      form: {
        addTitle: "Додати послугу",
        editTitle: "Редагувати послугу",
        service: "Послуга",
        servicePlaceholder: "Оберіть послугу",
        duration: "Тривалість",
        price: "Ціна, €",
        buffer: "Буфер, хв",
        bufferHint: "Час після запису",
      },
      detach: {
        title: "Прибрати послугу?",
        description: "Послугу буде відчеплено від майстра. Атрибути зв'язку буде втрачено.",
        confirm: "Прибрати",
      },
      a11y: {
        addedAnnounce: "{name} додано",
        savedAnnounce: "{name} оновлено",
        detachedAnnounce: "{name} прибрано",
      },
    },
    portfolio: {
      title: "Портфоліо",
      description: "Фотографії робіт майстра",
      empty: "Фотографій робіт ще немає",
      loading: "Завантаження...",
      error: "Помилка завантаження",
      retry: "Повторити",
      addPhoto: "Додати фото",
      full: "Портфоліо повне (максимум 20 фото)",
      cover: "Обкладинка",
      upload: {
        title: "Додати фото",
        fileLabel: "Фото роботи",
        serviceLabel: "Послуга (необов'язково)",
        noTag: "Без тегу (загальна робота)",
        submit: "Завантажити",
        cancel: "Скасувати",
        preview: "Прев'ю",
      },
      remove: {
        title: "Видалити фото",
        description: "Це фото буде видалено з портфоліо. Відновити неможливо.",
        confirm: "Видалити",
        cancel: "Скасувати",
      },
      errors: {
        full: "Портфоліо вже містить 20 фото",
        serviceNotOffered: "Майстер не надає цю послугу",
        unsupportedType: "Непідтримуваний тип зображення (лише JPEG, PNG)",
        invalidImage: "Зображення пошкоджено або невалідне",
        tooLarge: "Файл занадто великий",
        reorderFailed: "Не вдалося змінити порядок — спробуйте ще раз",
        uploadFailed: "Помилка завантаження",
        masterGone: "Майстра не знайдено",
      },
      a11y: {
        photoAlt: "Фото роботи",
        taggedPhotoAlt: "Фото роботи — {service}",
        photoAdded: "Фото додано до портфоліо",
        photoDeleted: "Фото видалено з портфоліо",
        photoMoved: "Фото переміщено на позицію {position} з {total}",
        addPhoto: "Додати фото",
        moveBack: "Перемістити назад",
        moveForward: "Перемістити вперед",
        deletePhoto: "Видалити фото",
      },
    },
  },
  journal: {
    loadError: "Не вдалося завантажити розклад",
    retry: "Спробувати знову",
    toolbar: {
      today: "Сьогодні",
      prevDay: "Попередній день",
      nextDay: "Наступний день",
      dateLabel: "Навігація по датах",
      viewSwitcher: "Перемкнути вигляд",
      viewGrid: "Сітка",
      viewList: "Список",
    },
    masterTabs: {
      all: "Всі",
      dayOff: "вих.",
      dayOffAria: "вихідний",
    },
    workingCount: "{n} з {m} майстрів",
    summary: {
      completed: "виконано {count}",
      revenue: "виручка {amount}",
    },
    empty: {
      noMasters: "Сьогодні ніхто не працює",
      noBookings: "Записів немає",
      selectMaster: "Оберіть майстра у вкладках",
    },
    actions: {
      addBooking: "Новий запис",
      reschedule: "Перенести",
      cancel: "Скасувати",
    },
    create: {
      title: "Новий запис",
      close: "Закрити",
      master: "Майстер",
      selectMaster: "Оберіть майстра",
      service: "Послуга",
      selectService: "Оберіть послугу",
      clientName: "Ім'я клієнта",
      clientPhone: "Телефон",
      time: "Час",
      submit: "Додати запис",
      servicesLoadError: "Не вдалося завантажити послуги. Спробуйте переобрати майстра.",
      noServicesForMaster: "Для цього майстра послуги не налаштовано",
    },
    reschedule: {
      title: "Перенести запис",
      close: "Закрити",
      master: "Майстер (змінити)",
      selectMaster: "Оберіть майстра",
      date: "Дата",
      dateGroupLabel: "Дата перенесення",
      currentDay: "поточна",
      todayDay: "сьогодні",
      time: "Новий час",
      submit: "Зберегти зміни",
    },
    cancel: {
      title: "Скасувати запис",
      description: "Запис буде скасовано. Цю дію не можна скасувати.",
      reason: "Причина (необов'язково)",
      confirm: "Скасувати запис",
      close: "Назад",
    },
    dateTimePicker: {
      idleHint: "Оберіть майстра і послугу, щоб побачити доступний час",
      timeLabel: "Оберіть час",
      hoursLabel: "Години",
      minutesLabel: "Хвилини",
    },
    slotPicker: {
      empty: "Немає вільних слотів",
      loading: "Завантаження слотів…",
      error: "Не вдалося завантажити слоти",
      emptyForDate: "На обрану дату вільних слотів немає",
      emptyToday: "Вільного часу сьогодні не залишилось",
    },
    errors: {
      slotTaken: "Слот щойно зайняли. Оберіть інший час.",
      concurrentModification: "Запис змінився. Оновіть і повторіть.",
      outsideWorkingHours: "Час поза робочими годинами майстра.",
      notEditable: "Цей запис більше не можна редагувати.",
      serviceNotConfigured: "Майстер більше не надає цю послугу.",
      invalidPhone: "Невірний формат телефону.",
      invalidClientName: "Вкажіть коректне ім'я клієнта.",
      notFound: "Запис вже не існує.",
      reloadAction: "Оновити",
    },
    a11y: {
      blockLabel: "{service}, {client}, {start}–{end}, {master}, {status}",
      createdAnnounce: "Запис створено",
      rescheduledAnnounce: "Запис перенесено",
      cancelledAnnounce: "Запис скасовано",
      bookingActions: "Дії з записом",
      bookFreeSlot: "Записати на {time}",
    },
    status: {
      scheduled: "Заплановано",
      completed: "Виконано",
      cancelled: "Скасовано",
    },
    agenda: {
      dayOff: {
        title: "Вихідний",
        subtitle: "{name} сьогодні не працює. Записи недоступні.",
      },
      empty: {
        title: "Записів на цей день немає",
        workingHours: "{name} працює {start}–{end}",
      },
      duration: {
        hm: "{h} год {m} хв",
        h: "{h} год",
        m: "{m} хв",
      },
      freeSlot: {
        start: "Зміна починається о {time} · {duration}",
        end: "Зміна завершена · вільно {duration}",
        midLabel: "Вільно",
        book: "Записати",
      },
    },
    timeBlock: {
      busy: "Зайнято",
      createTitle: "Заблокувати час",
      deleteTitle: "Видалити блок",
      deleteDescription: "Цей блок часу буде видалено для майстра.",
      masterLabel: "Майстер",
      selectMaster: "Оберіть майстра",
      rangeLabel: "Проміжок часу",
      reasonLabel: "Причина",
      reasonPlaceholder: "Напр.: обід, перерва",
      submit: "Заблокувати",
      close: "Закрити",
      confirmDelete: "Видалити",
      cancelDelete: "Скасувати",
      createdAnnounce: "Час заблоковано",
      errors: {
        overlapBlock: "Цей час перетинається з іншим блоком майстра.",
        overlapBooking: "Цей час перетинається з наявним записом.",
        invalidRange: "Час завершення має бути пізніше за початок.",
        reasonTooLong: "Причина задовга (макс. 200).",
        notFound: "Блок уже видалено.",
      },
    },
    rebuildPlaceholder: "Розділ у розробці",
  },
  auth: {
    login: {
      title: "Увійти в кабінет",
      submit: "Увійти",
      forgotPassword: "Забули пароль?",
      noAccount: "Немає акаунта?",
      signUp: "Зареєструватися",
      supportPrompt: "Виникли проблеми?",
      supportLink: "Напишіть у підтримку",
    },
    brand: {
      title: "Керуйте компанією в одному місці",
      subtitle: "Записи, майстри й аналітика — у єдиній панелі.",
      props: [
        "Онлайн-запис 24/7",
        "Журнал і нагадування клієнтам",
        "Аналітика й підсумки дня",
      ],
    },
    fields: {
      email: "Email",
      emailPlaceholder: "you{'@'}example.com",
      password: "Пароль",
      passwordPlaceholder: "Ваш пароль",
      remember: "Запам'ятати мене",
    },
    errors: {
      // ЄДИНИЙ login-override, що лишається в auth.* (ADR-0010 D7).
      invalidCredentials: "Невірний email або пароль",
      validation: {
        emailRequired: "Введіть email",
        emailInvalid: "Невірний формат email",
        passwordRequired: "Введіть пароль",
      },
    },
  },
  onboarding: {
    title: 'Налаштуймо салон',
    subtitle: 'Виконайте кроки, щоб відкрити салон для клієнтів',
    progress: '{n} з {total}',
    steps: {
      services: {
        label: 'Послуги',
        desc: 'Додайте перелік послуг, які надає ваш салон',
      },
      masters: {
        label: 'Майстри',
        desc: 'Додайте майстрів, які працюють у вашому салоні',
      },
      pricing: {
        label: 'Ціни й час послуг',
        desc: 'Встановіть тривалість і вартість кожної послуги',
        lockHint: 'Спочатку додайте послуги та майстрів',
      },
      schedule: {
        label: 'Розклад роботи майстрів',
        desc: 'Вкажіть години роботи кожного майстра',
        lockHint: 'Спочатку додайте майстра',
      },
      profile: {
        label: 'Профіль салону',
        desc: 'Заповніть інформацію про салон для сайту',
        tag: 'для сайту',
      },
    },
    cta: {
      start: 'Почати',
      open: 'Відкрити',
      showHint: 'Показати підказку',
    },
    fullSetup: {
      title: 'Повний сетап завершено',
      description: 'Салон налаштований і видимий клієнтам',
    },
    stateError: 'Не вдалось перевірити стан, спробуйте оновити',
    retry: 'Оновити',
  },
  errors: {
    validation: "Перевірте введені дані",
    sessionExpired: "Сесію завершено. Увійдіть знову",
    forbidden: "Дію відхилено. Оновіть сторінку та спробуйте знову",
    notFound: "Не знайдено",
    conflict: "Дію неможливо виконати: ресурс використовується",
    rateLimited: "Забагато спроб. Спробуйте пізніше",
    server: "Щось пішло не так. Спробуйте пізніше",
    network: "Сервер тимчасово недоступний. Спробуйте ще раз",
    unknown: "Сталася помилка. Спробуйте пізніше",
    boot: {
      title: "Не вдалося завантажити кабінет",
      description: "Перевірте з'єднання та спробуйте ще раз",
      retry: "Спробувати знову",
      loading: "Завантаження кабінету…",
    },
  },
  publicPages: {
    signup: {
      title: "Реєстрація",
      subtitle: "Самостійна реєстрація скоро зʼявиться. Напишіть нам — і ми створимо ваш кабінет.",
      backToLogin: "Повернутися до входу",
    },
    forgotPassword: {
      title: "Відновлення пароля",
      subtitle: "Скидання пароля скоро зʼявиться. Напишіть у підтримку — ми допоможемо увійти.",
      backToLogin: "Повернутися до входу",
    },
  },
  clients: {
    title: "Клієнти",
    subtitle: "Картки клієнтів салону: додавайте, знаходьте, редагуйте та видаляйте.",
    add: "Додати клієнта",
    backToList: "До списку",
    loading: "Завантаження…",
    listError: "Не вдалося завантажити клієнтів",
    loadError: "Не вдалося завантажити клієнта",
    retry: "Спробувати знову",
    search: {
      label: "Знайти клієнта",
      placeholder: "Імʼя або телефон",
      clear: "Очистити пошук",
      searching: "Пошук…",
      minLengthHint: "Введіть щонайменше 2 символи для пошуку.",
      error: "Не вдалося виконати пошук",
    },
    results: {
      title: "Результати",
      limitHint: "Показано перші {count} збігів. Уточніть запит, щоб звузити.",
      empty: "Нічого не знайдено",
      emptyBody: "Перевірте написання або створіть нову картку клієнта.",
      emptyCta: 'Створити „{query}”',
    },
    recent: {
      title: "Останні",
      hint: "Нещодавно додані клієнти. Щоб знайти будь-кого з усієї бази — скористайтеся пошуком вище.",
    },
    empty: {
      title: "Клієнтів ще немає",
      body: "Додайте першого клієнта — його картка зʼявиться у списку.",
      cta: "Додати клієнта",
    },
    fields: {
      firstName: "Імʼя",
      lastName: "Прізвище",
      phone: "Телефон",
      email: "Email",
      hint: { optional: "необовʼязково" },
    },
    create: {
      title: "Новий клієнт",
      close: "Закрити",
      submit: "Додати клієнта",
    },
    actions: {
      create: "Додати клієнта",
      save: "Зберегти",
      cancel: "Скасувати",
      delete: "Видалити",
    },
    delete: {
      title: "Видалити клієнта?",
      confirm: "Дія незворотна. Картку клієнта {name} буде видалено без можливості відновлення.",
    },
    notFound: {
      title: "Клієнта вже немає",
      body: "Цього клієнта видалено або посилання неправильне.",
      backCta: "На список",
    },
    dangerZone: {
      description: "Видалення клієнта незворотне.",
    },
    a11y: {
      createdAnnounce: "Клієнта {name} додано",
      savedAnnounce: "Зміни картки {name} збережено",
      deletedAnnounce: "Клієнта видалено",
      searchResults: "Знайдено {count}",
      avatarLabel: "Аватар клієнта",
    },
    errors: {
      firstNameRequired: "Введіть імʼя",
      phoneRequired: "Введіть телефон",
      nameTooLong: "Занадто довге значення (максимум 100 символів)",
      invalidName: "Перевірте імʼя та прізвище",
      invalidEmail: "Невірний формат email",
      invalidPhone: "Невірний формат телефону",
      phoneExists: "Клієнт із таким номером телефону вже існує",
      notFound: "Клієнта вже немає",
    },
  },
  salon: {
    title: "Профіль салону",
    loading: "Завантаження…",
    loadError: "Не вдалося завантажити профіль салону",
    retry: "Спробувати знову",
    profile: {
      title: "Основна інформація",
      fields: {
        name: "Назва салону",
        address: "Адреса",
        phone: "Телефон",
        description: "Опис",
      },
      hint: {
        name: "обовʼязково",
        description: "до 1000 символів",
      },
      save: "Зберегти",
      saved: "Зміни збережено",
      errors: {
        nameRequired: "Вкажіть назву салону",
        nameInvalid: "Перевірте назву (до 255 символів)",
        addressTooLong: "Адреса занадто довга (до 255 символів)",
        phoneTooLong: "Телефон занадто довгий (до 32 символів)",
        descriptionTooLong: "Опис занадто довгий (до 1000 символів)",
        saveFailed: "Не вдалося зберегти",
        notFound: "Профіль салону не знайдено",
      },
    },
    gallery: {
      title: "Фото інтерʼєру",
      loadError: "Не вдалося завантажити фото",
      empty: "Додайте перше фото інтерʼєру",
      addPhoto: "Додати фото",
      uploaded: "Фото завантажено",
      deleted: "Фото видалено",
      full: "Максимум 10 фото",
      errors: {
        full: "Досягнуто максимум 10 фото",
        unsupportedType: "Підтримуються лише JPEG та PNG",
        invalidImage: "Не вдалося прочитати зображення",
        tooLarge: "Файл завеликий",
        uploadFailed: "Не вдалося завантажити фото",
        reorderFailed: "Не вдалося змінити порядок",
      },
      a11y: {
        photoAlt: "Фото інтер'єру {n}",
        moveLeft: "Перемістити фото {n} лівіше",
        moveRight: "Перемістити фото {n} правіше",
        delete: "Видалити фото {n}",
        moved: "Фото переміщено на позицію {pos} з {total}",
        cover: "Головне фото",
      },
      deleteConfirm: {
        title: "Видалити фото?",
        description: "Фото буде видалено безповоротно.",
        cancel: "Скасувати",
        confirm: "Видалити",
      },
    },
  },
  records: {
    dayEmpty: "Жоден майстер не працює цього дня",
    offWork: {
      label: "поза графіком",
    },
    actions: {
      pastTooltip: "Минулий запис",
    },
    aria: {
      gridLabel: "Розклад",
      createCell: "Обрати дію для клітинки",
      dateStrip: "Вибір дати",
    },
    createStub: {
      title: "Незабаром",
      message: "Створення запису буде доступне незабаром",
    },
    chooser: {
      title: "Оберіть дію",
      createBooking: "Створити запис",
      blockTime: "Заблокувати час",
      cancel: "Скасувати",
      close: "Закрити",
    },
    createFlow: {
      sections: {
        client: "Клієнт",
        service: "Послуга",
        time: "Час",
      },
      clientStep: {
        searchPlaceholder: "Ім'я або телефон…",
        minLengthHint: "Введіть мінімум 2 символи",
        searching: "Пошук…",
        limited: "Показані перші результати",
        emptyTitle: "Нічого не знайдено",
        addNew: "Додати нового клієнта",
      },
      inlineCreate: {
        title: "Новий клієнт",
        firstName: "Ім'я",
        phone: "Телефон",
        lastName: "Прізвище",
        optional: "(необов'язково)",
        submit: "Створити і продовжити",
        back: "Назад до пошуку",
        phoneExists: "Клієнт з таким телефоном вже існує",
        createError: "Не вдалося створити клієнта",
      },
      summary: {
        change: "Змінити",
      },
      time: {
        nearestHint: "{tapped} недоступно — обрали {chosen}",
        emptyDay: "Вільного часу на цей день немає",
      },
      noServiceGuard: "Оберіть послугу, щоб зберегти запис",
    },
  },
  schedule: {
    title: "Графік",
    loading: "Завантаження…",
    loadError: "Не вдалося завантажити графік",
    retry: "Спробувати знову",
    empty: {
      title: "Розклад відсутній",
      body: "Додайте майстрів та налаштуйте їхній розклад.",
    },
    nav: {
      today: "Сьогодні",
      todayAria: "Повернутися до сьогодні",
      todayAnnounce: "Повернуто до поточного місяця",
      monthPickerAria: "Обрати місяць",
      monthSelectedAnnounce: "Обрано {month} {year}",
    },
    cell: {
      working: "Робочий день",
      dayOff: "вих",
      notSet: "не задано",
      aria: {
        working: "{master}, {date} — робоче вікно {start}–{end}",
        dayOff: "{master}, {date} — вихідний",
        notSet: "{master}, {date} — розклад не виставлено",
      },
    },
    sheet: {
      title: "Дії",
      createBooking: "Створити запис",
      fieldLabel: "Робочі години цієї дати",
      save: "Зберегти",
      invalidWindow: "Кінець має бути пізніше за початок",
      close: "Закрити",
    },
    a11y: {
      gridLabel: "Сітка графіку",
      masterColumn: "Майстер",
      loading: "Завантаження графіку…",
    },
    header: {
      setup: "Налаштувати",
    },
    mode: {
      banner: "Режим налаштування",
      subtitle: "оберіть клітинки для зміни",
      exit: "Скасувати",
      enteredAnnounce: "Увімкнено режим налаштування графіка",
    },
    selection: {
      selectColumnAria: "Виділити всю колонку — {date}",
      selectRowAria: "Виділити весь рядок — {master}",
      cellSelectedAria: "{master}, {date} — обрано",
    },
    editor: {
      dayOff: "Вихідний",
      start: "Початок",
      end: "Кінець",
      counter: "Оновити {count} клітинку | Оновити {count} клітинки | Оновити {count} клітинок",
      apply: "Застосувати",
    },
    bulk: {
      confirmTitle: "Застосувати розклад?",
      confirmWindow: "Встановити {start}–{end} для {count} клітинок.",
      confirmDayOff: "Позначити {count} клітинок як вихідний.",
      confirmOverwrite: "З них {count} уже мають години — їх буде замінено.",
      applyingLabel: "Застосування…",
      appliedToast: "Розклад оновлено",
      partialHint: "Дні без заданих годин показані як вихідні. Щоб задати години, відредагуйте ці дні окремо.",
      conflictBlocked: "На деяких датах є записи, що не вміщаються у нове вікно. Спершу розруліть їх у журналі.",
      masterGone: "Майстра більше немає. Графік оновлено.",
      invalidWindow: "Невалідне робоче вікно.",
      genericError: "Не вдалося застосувати розклад. Спробуйте ще раз.",
    },
    filter: {
      title: "Показати майстрів",
      subtitle: "Приховані майстри зникають з розкладу. Записи й дані не змінюються.",
      visibleOf: "Видно {n} з {m}",
      showAll: "Показати всіх",
      done: "Готово",
      triggerLabel: "Майстри",
      triggerAria: "Фільтр майстрів, приховано {count}",
      allHiddenTitle: "Усі майстри приховані",
      allHiddenBody: "Ви сховали всіх майстрів. Поверніть їх у розклад, щоб побачити графік.",
    },
  },
  monthPicker: {
    title: "Вибір місяця",
    prevYear: "Попередній рік",
    nextYear: "Наступний рік",
    currentSuffix: ", поточний місяць",
    disabledSuffix: ", недоступний",
    close: "Закрити",
  },
};
